import * as React from "react";
import { Kbd } from "@mantine/core";
const KeyboardKey = ({ children }) => /* @__PURE__ */ React.createElement(Kbd, null, children);
export default KeyboardKey;
